import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

export const EmptyState = ({ icon, title, description, actionLabel, onAction }) => {
  const IconComponent = icon || InboxIcon;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
        textAlign: 'center',
      }}
    >
      <IconComponent
        sx={{
          fontSize: 64,
          color: 'text.secondary',
          mb: 2,
        }}
      />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: 1.5,
            px: 2.5,
            py: 1,
            bgcolor: '#4185F1',
            border: 'none',
            boxShadow: `0 4px 14px ${alpha('#4185F1', 0.35)}`,
            '&:hover': {
              bgcolor: '#3574d9',
              border: 'none',
              boxShadow: `0 6px 18px ${alpha('#4185F1', 0.38)}`,
            },
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

